import React from 'react';

import InfoSvg from 'eventbrite_design_system/iconography/icons/InfoChunky';
import Icon from 'eventbrite_design_system/icon/Icon';
import withTooltip from 'eventbrite_design_system/tooltip/withTooltip';
import './infoTooltip.scss';

const IconWithTooltip = withTooltip(Icon);

const InfoTooltip = ({ tooltipId, arrowLocation, text, superscript }) => (
    <div className={superscript && 'infotooltip--superscript'}>
        <IconWithTooltip
            size="xsmall"
            color="ui-700"
            type={<InfoSvg />}
            tooltipId={tooltipId}
            tooltipStyle="phab"
            tooltipArrowLocation={arrowLocation}
            tooltipText={
                <p
                    className="eds-text-bs eds-text-weight--regular"
                    style={{ maxWidth: 150 }}
                >
                    {text}
                </p>
            }
        />
    </div>
);

export default InfoTooltip;
